import { ReactNode, useEffect } from 'react'

import { switchBodyScroll } from '@models/Util'

import * as style from './style.module.sass'

type ModalProps = {
  type?: 'default' | 'overlay' | 'overlay-empty'
  show?: boolean
  outsideClick?: () => void
  children: ReactNode
}
const Modal = ({
  type = 'default',
  show = false,
  outsideClick,
  children,
}: ModalProps) => {
  useEffect(() => {
    setTimeout(() => switchBodyScroll(!show), 100)
  }, [show])

  return (
    <div
      className={style.container}
      data-type={type}
      data-show={show}
      onClick={outsideClick}
    >
      <div className={style.modal} onClick={event => event.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}

export default Modal
